import type { Serial } from "../serialport/Bindings.js";

// Stub bindings that do nothing
export const serial: Serial = {};
